var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPauseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.354,
    height: 33.087,
    viewBox: "0 0 23.354 33.087",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-pause",
    "data-name": "Icon ionic-ios-pause",
    transform: "translate(-9 -6.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2405",
    "data-name": "Trac\\xE9 2405",
    d: "M14.055,39.837H9.57c-.316,0-.57-.372-.57-.827V7.577c0-.455.253-.827.57-.827h4.486c.316,0,.57.372.57.827V39.01C14.625,39.464,14.372,39.837,14.055,39.837Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2406",
    "data-name": "Trac\\xE9 2406",
    d: "M26.43,39.837H21.945c-.316,0-.57-.372-.57-.827V7.577c0-.455.253-.827.57-.827H26.43c.316,0,.57.372.57.827V39.01C27,39.464,26.747,39.837,26.43,39.837Z",
    transform: "translate(5.354 0)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseIcon);
export default __webpack_public_path__ + "static/media/pauseIcon.b6bda84310a146b9b367dacd4f55f51a.svg";
export { ForwardRef as ReactComponent };